module.exports = __webpack_public_path__ + "unbind.e722236d2634c9623af4d451108f729c.hashedasset.svg";


//////////////////
// WEBPACK FOOTER
// ./app/components/form/BoundField/unbind.svg
// module id = 1590
// module chunks = 8